// Priority1 has no carrier list endpoint; these are the carriers seen in its rate quotes. The value is the SCAC (quote carrierCode).
const priority1Carriers = [
	{ label: '2 Day Transportation', value: 'TWDW' },
	{ label: 'A. Duie Pyle', value: 'PYLE' },
	{ label: 'AAA Cooper', value: 'AACT' },
	{ label: 'ABF Freight', value: 'ABFS' },
	{ label: 'Aberdeen Express', value: 'ABNE' },
	{ label: 'ACI Motor Freight', value: 'AGCE' },
	{ label: 'Averitt Express', value: 'AVRT' },
	{ label: 'Best Overnite Express', value: 'BTVP' },
	{ label: 'Central Air Freight', value: 'CENC' },
	{ label: 'Central Transport', value: 'CTII' },
	{ label: 'Cross Country Freight Solutions', value: 'CCYQ' },
	{ label: 'Dedicated Delivery Professionals', value: 'DDPP' },
	{ label: 'Dot-Line Transportation', value: 'DOLR' },
	{ label: 'Dugan Truck Line', value: 'DUBL' },
	{ label: 'EDI Express', value: 'EDXI' },
	{ label: 'Estes', value: 'EXLA' },
	{ label: 'FedEx Economy', value: 'FXNL' },
	{ label: 'FedEx Priority', value: 'FXFE' },
	{ label: 'Forward', value: 'FWDN' },
	{ label: 'Frontline Freight', value: 'FCSY' },
	{ label: 'Go2 Logistics', value: 'GTJN' },
	{ label: 'JP Express', value: 'JPXS' },
	{ label: 'Lee Jennings Target Express', value: 'JLEI' },
	{ label: 'Numark Transportation', value: 'NUMK' },
	{ label: 'Oak Harbor Freight', value: 'OAKH' },
	{ label: 'Old Dominion Freight Line', value: 'ODFL' },
	{ label: 'Pitt Ohio', value: 'PITD' },
	{ label: 'R&L Carriers', value: 'RLCA' },
	{ label: 'Rist Transport', value: 'HWEP' },
	{ label: 'Roadrunner Transportation Systems', value: 'RDFS' },
	{ label: 'Saia LTL Freight', value: 'SAIA' },
	{ label: 'SalSon Logistics', value: 'SLSN' },
	{ label: 'Southeastern Freight', value: 'SEFL' },
	{ label: 'Southwestern Motor Transport', value: 'SMTL' },
	{ label: 'Sunset Pacific', value: 'SFPA' },
	{ label: 'TForce Freight', value: 'UPGF' },
	{ label: 'U.S. Road Freight Express', value: 'USRD' },
	{ label: 'WARD Trucking', value: 'WARD' },
	{ label: 'WARP', value: 'WTCH' },
];

export { priority1Carriers };
